export const defaultState = () => ({
  listaLotesDestinoPreAlojamento: [],
  qtTotalDiasVazio: 0,
  listaLotesDestinoAlojamento: [],
  listaLotesAlocados: [],
  cacheLoteAlocado: null,
  loadingLoteDestinoPreAlojamento: false,
  loadingLoteDestinoAlojamento: false,
});

const state = defaultState();

export default state;
